/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { logout } from 'store/reducers/authSlice';
import { showSnackbar } from 'store/reducers/snackbarSlice';

export const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers, { getState }) => {
        const { token } = (getState() as any).auth;

        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }

        headers.set('Content-Type', 'application/json');
        return headers;
    },
});

let isLoggingOut = false;

export const baseQueryWithSnackbar: typeof baseQuery = async (
    args,
    api,
    extraOptions,
) => {
    const result = await baseQuery(args, api, extraOptions);
    const { endpoint } = api;

    if (result.error && result.error.status === 401) {
        const isOnLoginPage = window.location.pathname === '/login';
        const { token } = (api.getState() as any).auth;

        const hasToken = Boolean(token);

        if (!isLoggingOut && !isOnLoginPage && hasToken) {
            isLoggingOut = true;

            api.dispatch(
                showSnackbar({
                    message: 'Sesja wygasła. Zaloguj się ponownie',
                    severity: 'error',
                }),
            );

            api.dispatch(
                logout(),
            );
            
            setTimeout(() => {
                window.location.replace('/login');
                isLoggingOut = false;
            }, 2500);
        }

        return result;
    }

    if (result.error) {
        const silentEndpoints = [
            'hasActiveSubscription',
            'getUserData',
            'getCategoriesByEntity',
            'getCategoryById',
            'getEntities',
            'getEntityById',
            'getTeamMembers',
            'getEvent',
            'getEventsByEntity',
            'getUserPoints',
            'getUserCurrentYearPoints',
            'getAllUsersPointsByEntity',
            'getActivePlans',
            'getPlanById',
            'getPlanByName',
            'getFreePlan',
            'getMySubscriptions',
            'getSubscriptionHistory',
            'getMyInvoices',
            'getPaymentMethods',
            'getInvoiceDetails',
            'retryInvoicePayment',
        ];

        if (silentEndpoints.includes(endpoint)) {
            return result;
        }

        const message =
            (extraOptions as any)?.errorMessage ??
            'Wystąpił błąd podczas wykonywania operacji.';

        api.dispatch(
            showSnackbar({
                message,
                severity: 'error',
            }),
        );

        return result;
    }

    if (api.type === 'mutation') {
        const silentEndpoints = [
            'login',
            'retryInvoicePayment',
            'refreshMySubscription',
        ];

        if (silentEndpoints.includes(endpoint)) {
            return result;
        }

        const message =
            (extraOptions as any)?.successMessage ??
            'Operacja zakończona sukcesem';

        api.dispatch(
            showSnackbar({
                message,
                severity: 'success',
            }),
        );
    }

    return result;
};
